import * as yup from "yup";
import { dateRangeRequiredMessage, requiredMessage } from "../../../shared/form/formValidatonRules";
import dayjs from "dayjs";

const MAX_DATE_RANGE_DAYS = 365;

export const salesVolumeAndThresholdsSchema = yup.object().shape({
  AgencyKey: yup.number().required(requiredMessage),
  IssuedDate: yup
    .array()
    .of(yup.string())
    .required(dateRangeRequiredMessage)
    .test("valid-range", `Date range cannot exceed ${MAX_DATE_RANGE_DAYS} days`, function (value) {
      if (!value || !value[0] || !value[1]) return true;
      const start = dayjs(value[0]).startOf("day");
      const end = dayjs(value[1]).startOf("day");
      return end.diff(start, "day") + 1 <= MAX_DATE_RANGE_DAYS;
    }),
  Include: yup
    .boolean()
    .when(
      [
        "ShowBelowThreshold",
        "ShowAtOrAboveThreshold",
        "ShowWithNoThreshold",
      ],
      {
        is: false,
        then: yup
          .boolean()
          .required("At least one of the options is required."),
      }
    ),
});
